import PropTypes from 'prop-types'
import { ParagraphMedium } from 'baseui/typography'

const Subtitle = ({ hidden, text }) => {
  if (hidden) {
    return null
  }
  return <ParagraphMedium>{text}</ParagraphMedium>
}

Subtitle.propTypes = {
  hidden: PropTypes.bool,
  text: PropTypes.string,
}

export default Subtitle
